import { Reveal, Eyebrow } from "./Reveal";
import { SITE } from "@/lib/site";
import { MapPin, Phone, Navigation, Clock } from "lucide-react";

export const Locations = () => {
  return (
    <section id="locations" data-testid="locations-section" className="py-24 lg:py-32 bg-[#F5F3EC] border-t border-[#E8DCC4]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal className="max-w-2xl">
          <Eyebrow>Visit Us</Eyebrow>
          <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-neutral-900" data-testid="locations-heading">
            Three showrooms, <span className="text-[#C9A227]">one standard of honesty</span>
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-neutral-600">
            Walk in for a free, no-pressure valuation — testing and weighing done right in front of
            you at any of our Texas showrooms.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-8">
          {SITE.locations.map((loc, i) => (
            <Reveal key={loc.name} delay={0.08 * i}>
              <div
                data-testid={`location-card-${i}`}
                className="bg-white border border-[#E8DCC4] rounded-sm p-8 h-full shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(201,162,39,0.10)] hover:-translate-y-1 transition-[box-shadow,transform] duration-500"
              >
                <h3 className="font-display text-2xl text-neutral-900">{loc.name}</h3>
                <p className="mt-5 flex items-start gap-3 text-sm text-neutral-600 leading-relaxed">
                  <MapPin size={16} strokeWidth={1.5} className="text-[#C9A227] shrink-0 mt-0.5" />
                  <span>
                    {loc.lines.map((line) => (
                      <span key={line} className="block">{line}</span>
                    ))}
                  </span>
                </p>
                <a
                  href={loc.phoneHref}
                  data-testid={`location-phone-${i}`}
                  className="mt-4 flex items-center gap-3 text-sm font-semibold text-neutral-900 hover:text-[#C9A227] transition-colors duration-300"
                >
                  <Phone size={16} strokeWidth={1.5} className="text-[#C9A227] shrink-0" />
                  {loc.phone}
                </a>
                <div className="mt-4 flex items-start gap-3 text-sm text-neutral-600" data-testid={`location-hours-${i}`}>
                  <Clock size={16} strokeWidth={1.5} className="text-[#C9A227] shrink-0 mt-0.5" />
                  <span>
                    {SITE.hours.map((h) => (
                      <span key={h.days} className="block leading-relaxed">
                        <span className="text-neutral-500">{h.days}:</span> {h.time}
                      </span>
                    ))}
                  </span>
                </div>
                <a
                  href={loc.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`location-directions-${i}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#C9A227] hover:text-[#A8871B] transition-colors duration-300"
                >
                  <Navigation size={14} strokeWidth={1.5} />
                  Get directions
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
